<template>
  <table-view ref="tableView" url="/sitepatrol/listForPage" :exportable="isAuthed('site_patrol_export')"
    export-url="/sitepatrol/download" export-file-name="工地巡查记录表" :filterable="false" :filter-form="dataForm"
    :headers="headers" :split-index="2" show-index single>
    <el-form slot="search" @keyup.enter.native="query" inline>
      <el-form-item label="站点名称">
        <el-select filterable="true" v-model="dataForm.siteId">
          <el-option v-for="b in siteList" :key="b.id" :label="b.siteName" :value="b.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名称">
        <el-select filterable="true" v-model="dataForm.userId">
          <el-option v-for="s in userList" :key="s.id" :label="s.nickName" :value="s.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="打卡日期">
        <el-date-picker type="date" v-model="dataForm.startDate" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker type="date" v-model="dataForm.endDate" value-format="yyyy-MM-dd"></el-date-picker>
      </el-form-item>
      <el-button @click="query" type="primary">查询</el-button>
    </el-form>
  </table-view>
</template>

<script>
import TableView from '@/components/templates/table-view'

export default {
  name: 'site-patrol',

  components: { TableView },

  data () {
    return {
      headers: [
        { id: 1, prop: 'nickName', label: '打卡人员' },
        { id: 2, prop: 'siteName', label: '工地名称' },
        { id: 3, prop: 'createTime', label: '打卡时间' }
      ],
      dataForm: {
        siteId: '',
        userId: '',
        startDate: '',
        endDate: ''
      },
      userList: [],
      siteList: [],
      loading: false
    }
  },
  created() {
    this.init()
  },

  methods: {
    async init() {
      let data = await this.$http({
        url: this.$http.adornUrl('/user/list'),
        method: 'post',
        data: {}
      })
      this.userList = data.datas

      data = await this.$http({
        url: this.$http.adornUrl('/site/list'),
        method: 'post',
        data: {}
      })
      this.siteList = data.datas
    },
    query () {
      this.$refs.tableView.queryData()
    }
  }
}
</script>
